import React from 'react'

const Connect = () => {
  return (
    <>
        <div className='bg-[#1d5ef3] p-6'>
            <div className='w-11/12 xl:max-w-screen max-w-screen-2xl mx-auto'>
                <div className="flex justify-between flex-col lg:flex-row">
                    <h4 className='text-2xl mb-0 mt-1 text-white'>
                        Want Top-Notch Primary Market Research Consulting? Get in touch with our team.
                    </h4>
                    <button className='btn'>Connect Now</button>
                </div>
            </div>
        </div>
    </>
  )
}
export default Connect;
